
import React from 'react';

const Introduction: React.FC = () => {
  return (
    <section id="introduction" className="py-20 bg-gradient-to-b from-beige-50 to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            <i className="ri-user-heart-line text-amber-600 mr-3"></i>
            弁護士紹介
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            地域の「負」動産問題解決に取り組む弁護士が、ご依頼者の個々の悩みに寄り添います
          </p>
        </div>

        {/* 弁護士写真と経歴を横並び */}
        <div className="grid lg:grid-cols-2 gap-12 items-start mb-12">
          {/* 弁護士写真 */}
          <div className="text-center lg:text-left">
            <div className="inline-block relative">
              <img
                src="https://static.readdy.ai/image/5e182d52a94dfeeda6703180d188c585/a2966f98f0812456d4200764c8bdbba2.jpeg"
                alt="弁護士 加藤信"
                className="w-80 h-80 object-cover object-top rounded-2xl shadow-2xl mx-auto"
              />
              <div className="absolute -bottom-4 -right-4 w-16 h-16 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center shadow-lg">
                <i className="ri-scales-3-line text-white text-2xl"></i>
              </div>
            </div>
          </div>

          {/* 弁護士情報 */}
          <div className="space-y-8">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-2">弁護士 加藤 信</h3>
              <p className="text-lg text-amber-600 font-medium mb-6">Shin Kato</p>
              
              <div className="bg-gradient-to-br from-amber-50 to-orange-50 p-6 rounded-xl border border-amber-100">
                <h4 className="font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-graduation-cap-line text-amber-600 mr-2"></i>
                  経歴
                </h4>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start space-x-2">
                    <i className="ri-arrow-right-s-line text-amber-600 mt-1"></i>
                    <span>2012年 愛知県立刈谷高校卒業</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-arrow-right-s-line text-amber-600 mt-1"></i>
                    <span>2016年 名古屋大学法学部卒業</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-arrow-right-s-line text-amber-600 mt-1"></i>
                    <span>2018年 名古屋大学法科大学院修了</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-arrow-right-s-line text-amber-600 mt-1"></i>
                    <span>2020年 弁護士登録（愛知県弁護士会）</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* 想い・使命をワイドに配置 */}
        <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-200">
          <h4 className="font-bold text-gray-900 mb-6 flex items-center text-xl">
            <i className="ri-heart-3-line text-red-500 mr-3"></i>
            地域への想いと使命
          </h4>
          <div className="text-gray-700 leading-relaxed space-y-4">
            <p>
              愛知県刈谷市で生まれ育ち、弁護士として相続案件に多数携わってきた私は、地域の皆様が抱える「負動産」問題の深刻さを身近に感じてきました。
            </p>
            <p>
              遺産分割の現場では、価値のない不動産の処分が争いの火種となり、親族同士の関係を悪化させるケースを数多く見てきました。「誰がこの土地を相続するのか」で意見が対立し、本来は円満に進むはずだった遺産分割が長期化してしまう――そんな光景を目の当たりにするたび、「紛争になる前に、もっと早く処分できていれば」と感じてきました。
            </p>
            <p>
              一方で、山林や農地、空き家などの処分は、適切に解決することで、ご依頼者様とご家族だけでなく、譲受人、さらには地域の活性化にも繋がる極めて公益性の高い取り組みであると確信しています。
            </p>
            <p>
              使われていない土地が、新たな持ち主の手で活用される。<br />
              固定資産税の負担から解放され、ご家族が安心して暮らせるようになる。<br />
              そして、地域全体の土地利用が最適化され、活性化に繋がる。
            </p>
            <p>
              これは、単なる不動産取引ではなく、「地域の未来を作る仕事」だと考えています。
            </p>
            <p>
              お困りの方々の声に耳を傾け、法的な専門知識を活かして解決策をご提案することで、ご依頼者様はもちろん、私が生まれ育った地域全体の発展に貢献したい――これが、私がこの事業に取り組む理由です。
            </p>
            <p className="font-medium text-gray-900">
              お一人で悩まず、まずはお気軽にご相談ください。<br />
              ご依頼者様の個々のお悩みに寄り添った、心を込めたサポートをお約束いたします。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Introduction;
